module.exports = __webpack_public_path__ + "static/34-6eb43b3c6fd7738c7b5d8d307fa6e81a.jpg";